import { Component, Input, OnInit } from '@angular/core';
import { FormArray, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

import { ActivitiesValidateResponse, ExtraInformationVM } from '@activities/entities/activities-booking';
import { AccordionType, AccordionSize } from '@design-system/components/templates/accordion/entities/accordion.types';
import { BOOKING_FORM_INPUTS, INVALID } from '@booking/constants/forms.constants';
import {
  TypographyFontFamily, TypographyFontSize, TypographyColor
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-extra-information',
  templateUrl: './extra-information.component.html',
  styleUrls: ['./extra-information.component.sass'],
  standalone: false
})
export class ExtraInformationComponent implements OnInit {

  @Input() validation: ActivitiesValidateResponse;
  @Input() extraInformationVM: ExtraInformationVM[] = [];
  @Input() bookingForm: UntypedFormGroup;
  @Input() isSubmitted = false;
  @Input() isMobile = false;

  public readonly accordionType = AccordionType.Card;
  public readonly accordionSize = AccordionSize.SM;

  public readonly fontFamily = TypographyFontFamily;
  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;

  constructor() { }

  ngOnInit(): void {
    this.bookingForm?.addControl(BOOKING_FORM_INPUTS.EXTRA_QUESTIONS, new FormArray([]))
  }

  get addDynamicElement(): UntypedFormArray {
    return this.bookingForm?.get(BOOKING_FORM_INPUTS.EXTRA_QUESTIONS) as UntypedFormArray;
  }

  public formIsInvalid(position: number): boolean {
    const form = this.addDynamicElement?.at(position);
    return form?.status === INVALID && this.isSubmitted;
  }

  public trackById(index: number): number {
    return index;
  }

}
